var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightDEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "32px",
    viewBox: "0 0 100 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_D",
    transform: "translate(-826.000000, -119.000000)",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(514.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.064318,0 L410.505569,0 C411.057854,-7.9498914e-15 411.505569,0.44771525 411.505569,1 L411.505569,31 C411.505569,31.5522847 411.057854,32 410.505569,32 L313.064318,32 C312.512033,32 312.064318,31.5522847 312.064318,31 C312.064318,30.7318243 312.172032,30.4748865 312.363273,30.2868832 L326.170771,16.7131168 C326.564615,16.3259402 326.570019,15.6927983 326.182843,15.2989548 C326.178853,15.2948966 326.174829,15.2908726 326.170771,15.2868832 L312.363273,1.7131168 C311.969429,1.32594021 311.964025,0.692798299 312.351201,0.298954763 C312.539205,0.107714194 312.796142,2.71307674e-16 313.064318,0 Z",
    id: "Rectangle-Copy-10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDEmpty);
export default __webpack_public_path__ + "static/media/rightDEmpty.f3993f985ab10cec0f4a152d5730f483.svg";
export { ForwardRef as ReactComponent };